import styled from 'styled-components'

const RecommendationPropertyChoicesStepTwo = styled.div`
  margin-top: 1rem;
`

export { RecommendationPropertyChoicesStepTwo }
